import React from 'react';
import { withRouter } from '../RouterCompatibility';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import SelectGoalTree from './SelectGoalTree';
import actions from './SelectGoalTree.actions';
import { getOffers, getGoals, getGoalActions } from './SelectGoalTree.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    offers: getOffers,
    goals: getGoals,
    goalActions: getGoalActions
});

const SelectGoalTreeComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            loadingOffers: state.selectGoalActions.loadingOffers,
            loadingGoals: state.selectGoalActions.loadingGoals,
            loadingGoalActions: state.selectGoalActions.loadingGoalActions
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            getListOffers: actions.getListOffers,
            getListGoals: actions.getListGoals,
            getListGoalActions: actions.getListGoalActions
        };
    }
)(SelectGoalTree);

export default withRouter(SelectGoalTreeComponent);
